import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

const ItemRow = ({ item, index, isDraggable }) => {
  const inner = (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        px: 1,
        py: 0.75,
        '&:hover': { bgcolor: 'action.hover' },
        borderRadius: 0.5,
      }}
    >
      <DragIndicatorIcon sx={{ color: 'text.disabled', fontSize: 16, flexShrink: 0 }} />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        {item.orderId ? (
          <>
            <Typography variant='body2' fontWeight={500}>
              {item.name || item.sku}
            </Typography>
            <Typography variant='caption' color='text.secondary'>
              Order: {item.orderId}&nbsp;·&nbsp;Qty: {item.quantity}
            </Typography>
          </>
        ) : (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant='body2' fontWeight={500}>
              {item.name || item.sku}
            </Typography>
            <Typography variant='caption' color='text.secondary'>
              ·&nbsp;Qty: {item.quantity}
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );

  if (!isDraggable) return inner;

  return (
    <Draggable draggableId={item.lineItemId} index={index}>
      {(provided, snapshot) => (
        <Box
          ref={provided.innerRef}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...provided.draggableProps}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...provided.dragHandleProps}
          sx={{
            opacity: snapshot.isDragging ? 0.7 : 1,
            cursor: snapshot.isDragging ? 'grabbing' : 'grab',
          }}
        >
          {inner}
        </Box>
      )}
    </Draggable>
  );
};

ItemRow.propTypes = {
  item: PropTypes.shape({
    lineItemId: PropTypes.string.isRequired,
    name: PropTypes.string,
    sku: PropTypes.string,
    orderId: PropTypes.string,
    quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  index: PropTypes.number.isRequired,
  isDraggable: PropTypes.bool,
};

ItemRow.defaultProps = {
  isDraggable: true,
};

export default ItemRow;
